import { useState } from 'react'

const inMemoryStorage = {}

const isStorageEnabled = () => {
  try {
    const test = 'test'
    localStorage.setItem(test, test)
    localStorage.removeItem(test)

    return true
  } catch (e) {
    console.warn('Error with local storage. Storage may not exist/be available, or it may be full.', e)
    return false
  }
}

const setItem = (key, value) => {
  if (isStorageEnabled()) {
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    inMemoryStorage[key] = JSON.stringify(value)
  }
}

const getItem = (key) => {
  if (isStorageEnabled()) {
    return getItemFromLocalStorage(key)
  }

  if (inMemoryStorage[key]) {
    return JSON.parse(inMemoryStorage[key])
  }

  return null
}

const getItemFromLocalStorage = (key) => {
  const item = localStorage.getItem(key)

  try {
    return JSON.parse(item)
  } catch(error) {
    return item
  }
}

const removeItem = (key) => {
  if (isStorageEnabled()) {
    localStorage.removeItem(key)
  } else {
    delete inMemoryStorage[key]
  }
}

const useItemReadOnly = (key) => {
  const [item] = useState(() => getItem(key))
  return item
}

export const LocalStorage = {
  getItem,
  setItem,
  removeItem,
  isStorageEnabled,
  useItemReadOnly,
}
